import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Icon from '../../../components/Icon';
import ClosableModal from '../../../components/Modal/ClosableModal';
import Loader from '../../../components/Loader';

import ImageDropZoneWithCrop from '../ImageDropZoneWithCrop';
import { addLogoCroppedImageBlob, addMediaLogoFile, addMediaLogoS3ScannedURI } from '../actions';
import messages from '../messages';
import './edit-modal-styles.css';

export class EditLogoModalComponent extends React.Component {
  static propTypes = {
    scid: PropTypes.string.isRequired,
    logoUpload: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    openModal: PropTypes.bool.isRequired,
    addMediaLogoFile: PropTypes.func.isRequired,
    addLogoCroppedImageBlob: PropTypes.func.isRequired,
    addMediaLogoS3ScannedURI: PropTypes.func.isRequired,
  }

  state = {
    uploading: false,
  };

  imageRef = null;

  fileUrl = null;

  goBack = () => {
    this.imageRef = null;
    this.setState({ uploading: false });
  }

  previewAndCloseModal = async (ImageState) => {
    const { croppedImageBlobDataStr } = ImageState;

    this.setState({ uploading: true });
    // run the mutation to scan the file for viruses and upload to s3
    try {
      const logoUploadResult = await this.props.logoUpload({
        variables: {
          input: {
            logoDataStr: croppedImageBlobDataStr,
          },
        },
      });
      // until this point we are sure that we need to save on state
      this.props.addMediaLogoFile(croppedImageBlobDataStr);
      this.props.addLogoCroppedImageBlob(ImageState.croppedImageBlob);

      this.setState({ uploading: false });
      if (!logoUploadResult.data.uploadPremiumHEMLogo.scanAndUploadSuccess) {
        return;
      } else {
        this.props.addMediaLogoS3ScannedURI(logoUploadResult.data.uploadPremiumHEMLogo.logoPath);
      }
    } catch (err) {
      // assume a bad upload if the mutation failed
      this.setState({ uploading: false });
      return;
    }

    this.closeModal();
  }

  closeModal = () => {
    if (this.props.onCloseModal) {
      this.props.onCloseModal();
    }
  };

  render() {
    const { uploading } = this.state;
    const { openModal, scid } = this.props;
    return (
      <ClosableModal
        open={openModal}
        onClose={this.closeModal}
      >
        { uploading && (
          <div styleName="uploading-image-spinner">
            <Icon name="image outline" color="teal" size="massive" />
            <Loader active inline />
            <FormattedMessage {...messages.imageUploading} />
          </div>
        )}
        { !uploading && (
          <ImageDropZoneWithCrop
            scid={scid}
            crop={{
              aspect: 1,
              width: 50,
              height: 50,
              x: 0,
              y: 0,
            }}
            headerText={messages.titleCropping}
            nevermindAction={this.closeModal}
            nextButtonText={messages.previewAndContinue}
            nextButtonAction={this.previewAndCloseModal}
          />
        )}
      </ClosableModal>
    );
  }
}

export default connect(null, { addLogoCroppedImageBlob, addMediaLogoFile, addMediaLogoS3ScannedURI })(EditLogoModalComponent);
